import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { API_PREFIX } from '../config';

// 用户时区设置
export const userTimeZoneSetting = (Timezone: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/proxy/api/user/settings`;
      const response = await api.commonRequest('PUT', url, {
        Timezone,
      });
      return await parsedResponse<IAPIresponse>(response);
    } catch (error) {
      console.error('failed:', error);
      // if (error instanceof APIError) {
      //   messageError(error.message);
      // }
      return {};
    }
  });
